import { useReducer } from 'react';
import { optimaChartData } from '../data';

const initialState = {
  optimaSize: undefined,
  optimaGroup: optimaChartData[0],
};

const optimaReducer = (existingData, action) => {
  const { optimaGroup } = existingData;
  const currentOptimaGroupIndex = optimaChartData.findIndex((group) => group.id === optimaGroup?.id) || 0;

  switch (action.type) {
    case 'setInitialOptimaGroup':
      if (!action.payload)
        alert(`Sorry, there was an error starting the test from your selected size. We've started from the largest group instead.`);
      return { ...existingData, optimaGroup: action.payload || optimaChartData[0] };
    case 'setOptimaSize':
      return { ...existingData, optimaSize: action.payload };
    case 'previousOptimaGroup':
      return { ...existingData, optimaGroup: optimaChartData[currentOptimaGroupIndex - 1] };
    case 'nextOptimaGroup':
      return { ...existingData, optimaGroup: optimaChartData[currentOptimaGroupIndex + 1] };
    default:
      return existingData;
  }
};

export const useOptimaData = () => {
  const [currentOptimaData, updateOptimaData] = useReducer(optimaReducer, initialState);
  return { currentOptimaData, updateOptimaData };
};
